import React from 'react';
import {
  FDBodyText,
  FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('OriginalValueLayout', (theme) => ({
  originalValueWithLine: {
    position: 'relative',
    '& > div': { // add spacing between the input above and the original value label
      padding: theme.spacing(1, 0),
    },
    '&& p.FD-MuiTypography-root': {
      // The following styles are now applied directly to the p to give it a background
      // and make it sit on top of the lines.
      backgroundColor: theme.palette.facet.lightGray,
      color: theme.palette.text.secondary,
      paddingLeft: theme.spacing(1),
      zIndex: 100, // This will ensure the div is on top of the lines.
    },
    '&::before': { // Vertical line pseudo-element
      content: '""',
      position: 'absolute',
      top: -4, // Adjust this value to set the starting point of the line
      bottom: 17, // Align the bottom of the line with the bottom of the parent
      left: -31, // Adjust this value to horizontally align the line with the icon
      width: theme.spacing(0.25), // The thickness of the line
      backgroundColor: theme.palette.facet.stone600, // The color of the line
      zIndex: 0,
    },
    '&::after': { // Horizontal line pseudo-element
      content: '""',
      position: 'absolute',
      bottom: 17, // Align the bottom of the line with the bottom of the parent
      left: -31, // Adjust this value to horizontally align the line with the icon
      right: 0, // Set the right edge of the line to the right edge of the parent
      height: theme.spacing(0.25), // The thickness of the line
      backgroundColor: theme.palette.facet.stone600,
      zIndex: 0,
    },
  },
}));

const OriginalValueLayout = ({ label, value }) => {
  const classes = useStyles();
  if (!value) {
    return null;
  }

  return (
    <div className={classes.originalValueWithLine}>
      <FDStack justifyContent={'flex-end'} spacing={1}>
        <FDBodyText size={'sm'} value={`${label} ${value}`} color={'textSecondary'} />
      </FDStack>
    </div>
  );
};

OriginalValueLayout.propTypes = {
};

export default OriginalValueLayout;
